import { render, staticRenderFns } from "./ThePage.vue?vue&type=template&id=098b361c&"
import script from "./ThePage.vue?vue&type=script&lang=js&"
export * from "./ThePage.vue?vue&type=script&lang=js&"
import style0 from "./ThePage.vue?vue&type=style&index=0&id=098b361c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports